export default {
  message: {
    hello: '안녕하세요',
    welcome: '저희 웹사이트에 오신 것을 환영합니다!',
    login: '로그인',
    logout: '로그아웃',
    about: '회사 소개',
    contact: '문의하기',
    news: '뉴스',
    home: '홈',
    industry: '산업 응용',
    support: '지원',
    faq: '자주 묻는 질문',
    privacy: '개인정보 처리방침',
    userCenter: '사용자 센터',
    myOrder: '내 주문',
    myPlan: '내 플랜',
    myTeam: '내 팀',
    profile: '프로필',
    myMessage: '내 메시지',
    exit: '로그아웃',
    language: '언어',
    zh: '중국어',
    en: '영어',
    ja: '일본어',
    ko: '한국어',
    industryNews: '산업 뉴스',
    techNews: '기술 동향',
    service: '고객 상담',
    onlineExperience: '온라인에서 최고의 압축을 체험하세요',
    getPro: '개인/팀 PRO 멤버십 해제 권한 받기',
    originalImage: '원본 이미지',
    compressed: '압축 후',
    saveSpace: '공간 절약',
    imageCompress: '이미지 압축',
    supportedImage: 'JPG/JPEG/PNG/GIF/WebP 지원',
    addImage: '이미지 추가',
    visitorImageTip: '방문자: 한 번에 최대 20장, 각 이미지 최대 5MB',
    originalVideo: '원본 비디오',
    videoCompress: '비디오 압축',
    supportedVideo: 'MP4/MOV/AVI/MKV/TS/FLV/Y4M/YUV 지원',
    addVideo: '비디오 추가',
    visitorVideoTip: '방문자: 한 번에 1개만, 최대 60MB',
    scrollDown: '아래로 스크롤하면 더 멋진 기능이 있습니다',
    windows32: 'Windows(32비트) 다운로드',
    windows64: 'Windows(64비트) 다운로드',
    selectedUsers: '이미',
    users: '명의 사용자가 선택함',
    ourPartners: '우리의 파트너',
    localCompressSoftware: '로컬 비디오 및 이미지 압축 소프트웨어',
    noFileLimit: '파일 수 및 크기 제한 없음',
    vipRights: 'VIP 혜택 공유｜온라인+로컬',
    customCompress: '다양한 요구에 맞춘 맞춤 압축 설정',
    folderOneClick: '폴더 원클릭 압축',
    address: '중국 심천시 남산구 도원가 두학로 9호 국가 슈퍼컴퓨팅 심천센터 과학연구동 7층',
    quickNav: '빠른 네비게이션',
    technologyIntro: '기술 소개',
    price: '가격',
    copyright: '심천즈후이린 네트워크 테크놀로지 유한회사',
    icp: '粤ICP备20048602号-2',
    legal: '법률 성명',
    siteMap: '사이트맵',
    newsBannerTitle: 'ZHL 압축 기술 산업 응용',
    newsBannerDesc: 'ZHL 압축(API/SDK) 효율적. 안전. 빠름. 전문적',
    contactForApi: 'API/SDK 문의는 저희에게 연락하세요',
    getDoc: '설명서 받기',
    techFeatures: '기술 특징',
    efficientConvenient: '효율적·편리',
    efficientConvenientDesc: 'API/SDK 압축 솔루션이 성숙하고, 표준화된 문서와 전체 기술 지원으로 기업 개발 통합이 더욱 편리해져 ZHL 압축 기술을 빠르게 누릴 수 있습니다',
    safeStable: '안전·안정',
    safeStableDesc: '수억 번 테스트되어 서버가 안전하고 안정적이며, 전송 데이터가 완전히 암호화됩니다. 압축 처리 후 사용자 데이터는 자동으로 삭제되어 사용자 개인정보 보안을 보장합니다.',
    powerfulAlgorithm: '강력한 알고리즘',
    powerfulAlgorithmDesc: '여러 독립적인 자체 개발 알고리즘을 기반으로 대량 데이터 훈련과 실전 비즈니스 시나리오로 지원되어 소스 파일 무결성을 보장하는 데 전념합니다.',
    multiLanguageSupport: '다국어·다시스템 지원',
    multiLanguageSupportDesc: 'C, C++, Java, Go 등 여러 프로그래밍 언어가 Linux와 Windows 플랫폼에 적용 가능합니다. 개인화된 맞춤 서비스는 문의해 주세요.',
    techAdvantages: '기술적 우위',
    techAdvantagesDesc: '독립적인 지적재산권을 가진 독립 알고리즘, 하위 계층에서 제어 가능하고 조정 가능(고객 요구에 따라 압축 전략을 유연하게 조정 가능). 인공지능과 머신러닝 기술을 기반으로 효과를 지속적으로 최적화. 압축비, 압축 속도, 압축 품질이 업계 선두 수준(구체적인 파일 형식에 따라 정도가 다름). 수학적 관계와 AI 자기학습 아키텍처를 기반으로 리소스 점유가 적고, 하드웨어 요구사항이 낮으며, 유연하게 배포 가능. 넓은 파일 타입과 다시스템 지원. 무손실 압축으로 파일 무결성을 보장하고, 최고 소프트웨어보다 70-80% 성능이 우수함(7-ZIP 등의 소프트웨어).',
    techPrinciples: '기술 원리',
    techPrinciplesDesc: '머신러닝과 AI 모델이 수백만 개의 데이터 포인트를 분석하여 수학적 관계를 발견하고, 자체 개발 알고리즘을 사용하여 다양한 타입의 파일의 데이터와 바이너리 정보를 처리하여 이전에는 압축할 수 없었던 파일 타입의 압축을 가능하게 하고 100% 무손실 압축을 실현합니다.',
    imageCompressSdk: '이미지 압축 SDK',
    medicalImageSdk: '의료 이미지 압축 SDK',
    textLogSdk: '텍스트·로그 압축 SDK',
    videoStreamSdk: '비디오 스트림 실시간 압축 SDK',
    supportedFormats: '지원 형식·운영체제',
    supportedFormatsImage: '지원 형식: bmp/jpg/png/tif/gif/pcx/tga/exif/fpx/svg/psd/cdr/pcd/dxf/ufo/eps/ai/raw/webp 시스템: Java 기반 SDK, Linux와 Windows 시스템 지원',
    supportedFormatsMedical: 'DICOM/NIFTI 시스템: Java 언어 기반, Linux와 Windows 지원.',
    supportedFormatsText: '지원 형식: text/RTF/jsonlog/sql/xml/doc//MIME/ASCII… 시스템: Java 언어 기반, Linux와 Windows 지원',
    supportedFormatsVideo: 'mp4/mov/mkv/avi/rm/rmvb/mpeg1-4/dat/wmv/3gp/amv/dmv/flv 시스템: C++ 언어 기반, Linux와 Windows 시스템 지원.',
    painPoints: '고통점·요구사항',
    painPointsImage: '고해상도 이미지 로딩 및 전송 속도가 느림, 대량 이미지 플랫폼 저장소 압력이 높음, 대량 저장 비용이 높음, jpeg 형식은 무손실 압축을 지원하지 않음',
    painPointsMedical: '의료 이미지 데이터 규모가 거대함(표준 병리 검사에서 5G/건에 도달 가능), 역사 데이터가 많고, 보존 기간이 김(10년 이상), 완전 무손실 압축 필요(이미지를 왜곡할 수 없음)',
    painPointsText: '중복 중복 데이터 혼잡, 사용자 데이터 폭발적 증가',
    painPointsVideo: '대역폭 월세 비용 절약, NVR 서버 조달 확장 비용 감소, 저장/백업/아카이브 리소스 절약, 운영·관리 비용 감소, 컴퓨터 또는 저장 장치 운영 부하 감소',
    featuresEffects: '특징·효과',
    featuresEffectsImage: '고품질 압축 품질 유지, 저장 공간과 비용의 효과적 절약, 파일 유통 가속화, 데이터센터 건설 비용 절약, 대역폭 월세 비용 절약, 웹페이지 로딩 속도 향상.',
    featuresEffectsMedical: '저장 공간을 대폭 감소, 의료기관의 저장/백업/아카이브 장비 구매 주기를 연장, 저장/백업/아카이브 비용 감소. 저장/백업/아카이브 리소스를 대폭 절약, 운영·관리 비용 감소. 컴퓨터 또는 저장 장치 운영 부하 감소. 데이터 전송 속도 가속화, 사용자 경험을 대폭 향상. 의료 이미지 데이터 검색과 호출 효율성 향상.',
    featuresEffectsText: '5가지 압축 속도에서 선택 가능. 압축 후 파일이 더 작고, 전송이 더 빠름. 압축 해제 파일 비용이 저장과 전송 비용보다 낮음.',
    featuresEffectsVideo: '금융, 데이터센터, 엣지 컴퓨팅, 블록체인, IoT 등. 보안 감시, 120 구급차, 지휘센터 스마트 교통 등.',
    suitableScenarios: '적합한 시나리오',
    suitableScenariosImage: '박물관, 아카이브, 금융업계, 정부기관, 대형 온라인 쇼핑 플랫폼, 뉴미디어, 소재 라이브러리, 영화·TV 등',
    suitableScenariosMedical: '주로 의료기관의 PACS 시스템, 의료 영상 클라우드 등의 시나리오에 적용',
    suitableScenariosText: '금융, 데이터센터, 엣지 컴퓨팅, 블록체인, IoT 등',
    suitableScenariosVideo: '보안 모니터링, 120 구급차, 지휘센터 스마트 교통 등',
    // FAQ page new translation keys
    faqTitle: '자주 묻는 질문',
    faqBreadcrumbHome: '홈',
    faqBreadcrumbService: '지원',
    faqBreadcrumbFaq: '자주 묻는 질문',
    faqQuestionAnswer: '질문과 답변',
    faqQ1Title: '방문자와 PRO 멤버의 차이점은 무엇인가요?',
    faqQ1Content: '방문자는 이미지 압축 기능을 사용할 때 한 번에 최대 20장의 이미지를 업로드할 수 있으며, 각 이미지는 최대 5MB로 제한됩니다. PRO 멤버는 한 번에 무제한으로 이미지를 업로드할 수 있고 각 이미지 크기에 제한이 없습니다. 비디오 압축의 경우, 방문자는 한 번에 1개의 비디오 파일을 업로드할 수 있으며, 각 비디오는 최대 60MB로 제한됩니다. PRO 멤버는 한 번에 1개의 비디오 파일을 업로드할 수 있으며, 각 비디오는 최대 2GB로 제한됩니다.',
    faqQ2Title: 'PRO 멤버가 되는 방법은 무엇인가요?',
    faqQ2Content: '사용자는 이메일이나 WeChat으로 웹사이트에 로그인할 수 있습니다. 사용자가 된 후, "가격"을 클릭하여 PRO 멤버십 구매 화면에 들어가고, 결제 후 우리의 영광스러운 PRO 멤버가 됩니다.',
    faqQ3Title: '업로드된 이미지/비디오는 어떻게 처리되나요?',
    faqQ3Content: '사용자가 업로드한 파일은 우리의 백엔드 서버를 통해 압축되며, 압축 후 사용자가 직접 다운로드합니다. 우리는 이러한 파일을 1시간만 보관하여 파일의 압축 상황을 기록하고 압축 기술을 최적화합니다. 1시간 후 즉시 삭제되며, 개인정보 유출 위험이 전혀 없습니다.',
    faqQ4Title: '인보이스를 신청하는 방법은 무엇인가요?',
    faqQ4Content: 'Yasubit에서 100원 이상 소비한 사용자는 고객 서비스 QQ를 통해 Yasubit 팀에 연락하여 인보이스를 요청할 수 있습니다.',
    faqQ5Title: '이미지나 비디오의 드래그 앤 드롭 업로드가 성공하지 않는 이유는 무엇인가요?',
    faqQ5Content: '브라우저 버전이 통일되지 않아 일부 사용자가 온라인 서비스를 사용할 때 압축이나 업로드 문제를 겪을 수 있습니다. Google Chrome이나 Firefox 브라우저 사용을 권장합니다.',
    faqQ6Title: '압축 설정은 어떻게 사용하나요?',
    faqQ6Content: '이미지 압축을 사용할 때, 사용자는 자신의 요구에 따라 압축 품질을 선택할 수 있습니다. 압축 품질이 높을수록(1이 최고) 압축된 파일이 커지고, 압축 품질이 낮을수록(13이 최저) 압축된 파일이 작아집니다. 비디오 압축은 이미지 압축과 같은 원리로 작동합니다. 하지만 비디오 압축은 압축 품질 외에도 비디오의 출력 형식을 선택할 수 있습니다. 압축 설정을 변경하지 않는 경우(기본 모드), 압축 비율과 압축 품질이 균형을 이루어, 압축된 비디오나 이미지는 원본 비디오나 이미지와 시각적·청각적으로 차이가 없습니다.',
    faqQ7Title: '왜 일부 이미지와 비디오는 압축 후 많이 작아지지 않나요?',
    faqQ7Content: 'Yasubit은 대부분의 비디오와 이미지에서 매우 좋은 압축 효과를 달성할 수 있습니다. 압축 효과가 일반적인 것들에 대해서는, 주요 이유는 이러한 비디오와 이미지가 이미 깊이 압축되어 있기 때문입니다. 따라서 명백한 시각적 차이를 일으키지 않고는 더 이상 압축할 수 없습니다. 사용자가 더 작은 압축 비디오와 이미지가 필요한 경우, 압축 설정을 통해 이를 달성할 수 있습니다.',
    faqQ8Title: 'Yasubit 클라이언트 소프트웨어 VIP와 Yasubit 웹사이트 PRO 멤버십 계정이 호환됩니까?',
    faqQ8Content: 'Yasubit 클라이언트 VIP는 Yasubit 웹사이트에 로그인하여 웹사이트와 동일한 PRO 멤버 압축 권한을 누릴 수 있습니다. 반대로, 웹사이트의 PRO 멤버도 클라이언트에 로그인하여 클라이언트와 동일한 VIP 압축 권한을 누릴 수 있습니다. 파일 크기와 수량에 제한이 없으므로 클라이언트 다운로드 사용을 권장합니다.',
    // Contact page translation keys
    contactTitle: '연락처',
    contactBreadcrumbHome: '홈',
    contactBreadcrumbService: '지원',
    contactBreadcrumbContact: '연락처',
    customerService: '고객 서비스',
    customerServiceQQ: 'QQ: 3985723352',
    contactCustomerService: '고객 서비스에 문의',
    businessCooperation: '비즈니스 협력',
    businessCooperationDesc: '비즈니스 협력에 대해서는 이메일로 문의해 주세요.',
    businessEmail: '이메일: support@zhihuilin.net',
    leaveMessage: '메시지 남기기',
    yourName: '이름:',
    contactInfo: '연락처:',
    yourEmail: '이메일:',
    messageContent: '메시지 내용 (200자 이내)',
    submit: '제출',
    submitSuccess: '제출 성공',
    submitFailed: '제출 실패, 나중에 다시 시도해 주세요',
    completeInfo: '모든 정보를 입력해 주세요',
    // About page translation keys
    aboutTitle: '회사 소개',
    aboutBreadcrumbHome: '홈',
    aboutBreadcrumbAbout: '회사 소개',
    companyProfile: '회사 개요',
    companyProfileContent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="http://www.zhihuilin.net/" target="_blank" title="ZHL 공식 홈페이지">선전 즈후이린 네트워크 테크놀로지 유한회사</a>는 2015년에 설립되었으며, 인공지능, 데이터 압축, 통신 전송 가속 등 기술 기반 알고리즘 및 그 응용 연구 개발에 전념하는 국가 하이테크 기업입니다. 완전한 독자적 지적 재산권을 보유한 차세대 인공지능 핵심 알고리즘과 딥러닝 기술, 세계 최고 수준의 데이터 초압축 기술, 글로벌 혁신 통신 전송 가속 기술을 잇따라 개발하였으며, 이러한 기술을 활용하여 많은 정부 및 기업 고객에게 업계 응용 솔루션과 맞춤형 제품을 제공합니다.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2017년 이후 회사는 여러 차례 국가 하이테크 기업으로 인정받았으며, 과학기술부 토치센터의 기술형 중소기업, 선전시 혁신형 중소기업, 고성장 기업, 선전시 소프트웨어 산업 협회 이사 단위, 선전시 정보기술 응용 혁신 연맹 회원 단위, 산업 인터넷 연맹, 공신부 과산금 프로젝트 라이브러리의 첫 입주 프로젝트 등으로 선정되었습니다. 기술 혁신 능력을 유지하기 위해 회사는 4명의(A급) 외국 전문가를 도입하였으며, 그 중 2명은 각각 외국 고급 인재와 광동성 외국 고급 인재 칭호를 받았습니다. 완전한 독자적 지적 재산권을 보유한 핵심 기술 발명 특허를 63건 출원하였고, 발명 특허 증서 7건, 기타 특허 증서 9건, PCT 국제 특허 8건, 소프트웨어 저작권 증서 66건, 과학 기술 조사 보고서 및 소프트웨어 테스트 보고서 40여 건, 등록 상표 12건을 획득하였습니다. 과학적이고 규범적인 관리를 위해 회사는 ISO 9001 품질 관리 시스템 인증, 지적 재산권 관리 시스템 인증을 통과하였습니다.<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 회사는 "성실을 바탕으로, 지속적인 혁신, 고객의 요구를 최대한 충족시키는 것"을 종지로 삼아, 우수한 제품과 고품질 서비스를 통해 고객의 비용 절감과 효율 증대, 에너지 절약 및 배출 감소를 실현하여 협력과 상생을 이루고자 합니다.<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style="font-size: 20px;">기반 기술의 지속적 혁신&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 완전한 독자적 지적 재산권&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 약 10년의 이론 및 기술 축적<br/><br/><br/></span><br/><br/>',
    companyHonor: '관련 자격',
    softwareCopyright: '소프트웨어 저작권',
    patentApplied: '출원된 발명 특허',
    patentGranted: '인증된 발명 특허',
    // Privacy page translation keys
    privacyTitle: '개인정보 처리방침',
    privacyBreadcrumbHome: '홈',
    privacyBreadcrumbService: '서비스 및 지원',
    privacyBreadcrumbPrivacy: '개인정보 처리방침',
    privacyContent: `Yasubit 이미지 압축 서비스를 사용하기 전에 본 약관을 주의 깊게 읽어주시기 바랍니다. 본 약관에 동의하지 않으시면 Yasubit 서비스를 중단하실 수 있습니다. 서비스를 이용하시면 본 약관의 모든 내용을 인정하고 수락한 것으로 간주됩니다.<br/><br/>1. Yasubit를 통해 압축된 멀티미디어 파일(생성된 임시 URL 링크 포함)은 사용자 또는 소유자가 제공한 것입니다(이하 "제3자 파일"이라 함). Yasubit는 온라인 압축 및 바이트 감소 기능만을 제공하며, Yasubit의 어떠한 의견이나 주장을 반영하지 않으며, 해당 제3자 파일의 어떠한 내용, 주장 또는 입장에 동의하거나 이를 지지하지 않습니다. Yasubit는 제3자 파일의 내용의 합법성, 정확성, 진실성, 적용성, 안전성 등에 대해 일체 책임을 지지 않습니다.<br/><br/>2. Yasubit가 제공하는 온라인 지능형 압축 기능은 제3자 파일을 일시적으로 저장해야 하지만, 장기적으로 저장하지는 않습니다. 제출/업로드된 모든 파일은 60분마다 자동으로 삭제되며, 삭제 후 파일 링크는 무효화됩니다. Yasubit가 제공하는 파일 링크에 과도하게 의존하지 마십시오.<br/><br/>3. Yasubit를 이용하여 다음과 같은 내용을 업로드, 압축, 다운로드, 복사, 게시, 전파 또는 전재해서는 안 됩니다:<br/>1) 헌법이 정한 기본 원칙에 반하는 내용<br/>2) 국가 안보를 해치거나, 국가 기밀을 누설하거나, 국가 정권을 전복하거나, 국가 통일을 파괴하는 내용<br/>3) 국가의 명예와 이익을 훼손하는 내용<br/>4) 민족적 증오나 차별을 선동하거나, 민족 단결을 파괴하는 내용<br/>5) 국가 종교 정책을 훼손하거나, 사이비 종교 및 봉건 미신을 선전하는 내용<br/>6) 유언비어를 퍼뜨리거나, 사회 질서를 혼란시키거나, 사회 안정을 해치는 내용<br/>7) 음란, 포르노, 도박, 폭력, 살인, 테러 또는 범죄를 교사하는 내용<br/>8) 타인을 모욕하거나 비방하거나, 타인의 합법적 권익을 침해하는 내용<br/>9) 법률 및 행정법규에서 금지하는 기타 내용<br/><br/>4. 제3자 파일의 내용(사진, 오디오, 비디오, 문서, 링크 등)을 이용하여 거래 또는 기타 행위를 하려는 경우, 해당 내용의 합법성, 정확성, 진실성, 실용성, 안전성(제3자 파일의 내용을 다운로드할 때 컴퓨터 바이러스에 감염될 수 있는지 여부 포함)을 신중히 판단하고, 충분한 예방 조치를 취해야 합니다. 내용의 합법성, 정확성, 진실성, 실용성, 안전성에 대해 확신이 없을 경우, 전문가와 상담하시기 바랍니다.<br/><br/>5. 제3자 파일의 정보, 서비스, 제품 등을 신뢰하거나 이용하거나, 이를 근거로 거래 등 행위를 하여 발생한 인명 피해, 재산 손실(다운로드로 인한 컴퓨터 바이러스 감염 포함), 명예 또는 신용 훼손, 저작권 또는 지적 재산권 침해 등 사건 및 그로 인한 손해에 대해 Yasubit는 일체 책임을 지지 않습니다. 이러한 책임은 제3자 파일의 소유자가 부담해야 합니다. Yasubit는 Yasubit와 직접 관련이 없는 거래 및 행위에 대해 어떠한 직접적, 간접적, 부수적, 파생적 손실 및 책임도 지지 않습니다.<br/><br/>6. Yasubit 서비스를 통해 얻은 제3자 파일의 내용이 합법적인 저작권을 침해한다고 판단되는 경우, "정보 네트워크 전파권 보호 조례"에 따라 서면으로 Yasubit에 신속히 통지하고, 신분증명서, 권리증명서, 상세한 침해 상황 증명을 제출해야 합니다. Yasubit는 위 서류를 받은 후 신속히 해당 내용에 대한 서비스 링크를 차단합니다. 링크가 차단된 제3자 파일의 소유자가 Yasubit의 판단이 타인의 합법적 저작권을 침해하지 않는다고 생각하는 경우, "정보 네트워크 전파권 보호 조례"에 따라 링크 차단이 해당 조례를 위반하지 않는다는 반통지를 Yasubit에 제출할 권리가 있습니다. 주장이 허위일 경우, 해당 조례에 따라 관련 법적 책임을 부담하게 됩니다.<br/><br/>7. Yasubit는 국가 법률 및 규정의 변경과 사용자 권익 보호 필요에 따라 본 약관을 수시로 수정할 수 있습니다. 변경된 약관은 본 약관 내에 명확히 표시되며, 최종 업데이트 날짜가 명시됩니다.`,
    buyNow: '지금 구매',
    payTip: 'WeChat Pay를 지원합니다. 개인정보 보호정책을 주의 깊게 읽어주세요. 서비스를 구매하면 자동으로 ',
    invoiceTip: '*누적 소비가 100위안을 초과하면 고객센터 QQ에 문의하여 인보이스를 발급받을 수 있습니다. 일반 인보이스와 전용 인보이스 모두 지원합니다.',
    price_1: '일일 회원',
    price_2: '월간 회원',
    price_3: '연간 회원',
    price_4: '2년 회원',
    price_5: '5년 회원',
    price_6: '10년 회원',
    price_7: '영구 회원',
    price_8: '분기 회원',
    price_desc_1: '일일 회원은 웹사이트에서만 사용 가능<br>이미지 수 무제한<br>파일 크기 무제한',
    price_desc_2: '클라이언트에서 동영상 크기 무제한<br>이미지 수 무제한<br>파일 크기 무제한',
    price_desc_3: '클라이언트에서 동영상 크기 무제한<br>이미지 수 무제한<br>파일 크기 무제한',
    price_desc_4: '클라이언트에서 동영상 크기 무제한<br>이미지 수 무제한<br>파일 크기 무제한',
    price_desc_5: '클라이언트에서 동영상 크기 무제한<br>이미지 수 무제한<br>파일 크기 무제한',
    price_desc_6: '클라이언트에서 동영상 크기 무제한<br>이미지 수 무제한<br>파일 크기 무제한',
    price_desc_7: '클라이언트에서 동영상 크기 무제한<br>이미지 수 무제한<br>파일 크기 무제한',
    price_desc_8: '클라이언트에서 동영상 크기 무제한<br>이미지 수 무제한<br>파일 크기 무제한',
    priceTitle: '작업 시나리오에 맞는 구매 계획을 선택하세요',
    proMemberCount: '이미 3876명이 PRO 버전 회원이 되었습니다',
    personalVersion: '개인 버전',
    teamVersion: '팀 버전',
    videoImageCompress: '비디오+이미지 압축',
    duration: '사용 기간',
    unlimitedVideoSize: '클라이언트에서 동영상 크기 무제한',
    unlimitedImageCount: '이미지 수 무제한',
    unlimitedFileSize: '파일 크기 무제한',
    selectTeamMember: '팀 멤버 수를 선택하세요',
    selectDuration: '회원 기간을 선택하세요',
    selectPackage: '패키지를 선택하세요',
    needMoreHelp: '더 많은 도움이 필요하신가요?',
    confirmPurchase: '정말로 하시겠습니까? 정말로 하시겠습니까? 정말로 하시겠습니까? 정말로 하시겠습니까? 정말로 하시겠습니까? 정말로 하시겠습니까?',
    yes: '예',
    no: '아니오',
    orderCreatedSuccess: '주문이 성공적으로 생성되었습니다',
    fileName: '파일 이름',
    originalFileSize: '원본 파일 크기',
    status: '상태',
    compressedFileSize: '압축 후 파일 크기',
    fileSizeReduced: '파일 크기 감소',
    merging: '병합 중...',
    resume: '계속',
    pause: '일시 중지',
    download: '다운로드',
    clickOrDragToAddImage: '클릭 또는 드래그하여 이미지 추가',
    continueToAddImage: '이미지 계속 추가',
    startCompress: '압축 시작',
    uploading: '업로드 중',
    compressing: '압축 중',
    downloadAll: '전체 다운로드',
    startDownloading: '패키징 후 다운로드 중입니다. 잠시만 기다려 주세요…',
    uploadedCount: '총 {count}장 이미지 업로드',
    downloadFailed: '다운로드 실패, 다시 시도해 주세요',
    uploadComponentInitFailed: '업로드 컴포넌트 초기화 실패, 새로고침 후 다시 시도해 주세요.',
    imageAlreadyExists: '이 이미지는 이미 존재합니다',
    allFilesExist: '모든 파일이 이미 존재합니다',
    guestMaxUpload: '게스트 사용자는 한 번에 최대 {count}장 이미지만 업로드할 수 있습니다.',
    guestImageSizeLimit: '이미지 {name}이(가) {size}MB 제한을 초과했습니다. 게스트 사용자는 {size}MB를 초과하는 이미지를 업로드할 수 없습니다.',
    uploadFailed: '{name} 업로드 실패: {msg}',
    noDownloadableFiles: '다운로드 가능한 압축 파일이 없습니다',
    createZipFailed: '압축 파일 생성 실패, 다시 시도해 주세요',
    resumeUploadFailed: '업로드 재개 실패, 다시 시도해 주세요',
    pauseUploadFailed: '업로드 일시 중지 실패, 다시 시도해 주세요',
    unknownError: '알 수 없는 오류',
    guestSurveyTitle: 'Yasubit 사이트 체험 설문조사',
    questionCount: '총 {count}개 질문',
    fillTextareaPlaceholder: '5자 이상 입력해 주세요',
    fillAllQuestions: '모든 문항을 작성해 주세요',
    submitSuccess: '제출이 완료되었습니다',
    compressionFailed: '압축 실패',
    compressionFailedWithName: '{name} 압축 실패',
    clickOrDragToAddVideo: "비디오를 클릭하거나 드래그하여 추가",
    continueToAddVideo: "비디오 계속 추가",
    guestQ1: '1.귀하의 성별은 무엇입니까?',
    guestQ1_option1: '남성',
    guestQ1_option2: '여성',
    guestQ2: '2.귀하의 연령대는?',
    guestQ2_option1: '18세 미만',
    guestQ2_option2: '18~24세',
    guestQ2_option3: '24~32세',
    guestQ2_option4: '32세 이상',
    guestQ3: '3.귀하의 직업은 무엇입니까?',
    guestQ3_option1: 'IT',
    guestQ3_option2: '디자인',
    guestQ3_option3: '사진',
    guestQ3_option4: '교사',
    guestQ3_option5: '학생',
    guestQ3_option6: '행정/재무',
    guestQ3_option7: '기타',
    guestQ4: '4.평소 어떤 유형의 콘텐츠에 관심이 있습니까?',
    guestQ4_option1: '오리지널 동영상',
    guestQ4_option2: '디자인 자료',
    guestQ4_option3: '사진',
    guestQ4_option4: 'IT 컨설팅',
    guestQ4_option5: '기타',
    guestQ5: '5.파일을 압축하는 목적은 무엇입니까?',
    guestQ5_option1: '웹사이트 구축',
    guestQ5_option2: '파일 업로드',
    guestQ5_option3: '파일 전송',
    guestQ5_option4: '프로그램 속도 향상',
    guestQ5_option5: '기타',
    guestQ6: '6.당사 사이트를 얼마나 자주 사용하십니까?',
    guestQ6_option1: '매일',
    guestQ6_option2: '매주',
    guestQ6_option3: '매월',
    guestQ6_option4: '가끔',
    guestQ7: '7.Pro 회원으로서 어떤 서비스를 기대하십니까?',
    guestQ7_placeholder: '5자 이상으로 의견을 입력해 주세요',
    guestQ8: '8.당사 사이트를 어떻게 알게 되었습니까?',
    guestQ8_option1: '바이두 검색',
    guestQ8_option2: '포럼(知乎, Tieba, CSDN 등)',
    guestQ8_option3: '지인 추천',
    guestQ8_option4: '기타',
    guestQ9: '9.당사 사이트의 온라인 압축 기능에 만족하십니까?',
    guestQ9_option1: '만족',
    guestQ9_option2: '불만족',
    guestQ10: '10.당사에 대한 의견이나 제안이 있으십니까?',
    unsupportedImageFormat: '지원되지 않는 이미지 형식입니다',
    unsupportedVideoFormat: '지원되지 않는 동영상 형식입니다',

  }
} 